module.exports = __webpack_public_path__ + "static/media/PORTADA.416deb83.JPG";